import AppFooterTauron from './appFooterTauron';

export default AppFooterTauron;
